import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { TranslateModule } from '@ngx-translate/core';
import { AddressSearchComponent } from './address-search/address-search.component';
import { CalendarLdComponent } from './calendar-ld/calendar-ld.component';
import { DatetimeSelectComponent } from './datetime-select/datetime-select.component';
import { DatetimeSelectModal } from './datetime-select/modal/datetime-select.modal';
import { DatetimeSelectModule } from './datetime-select/modal/datetime-select.module';
import { GoogleMapsComponentModule } from './map/google-map/modules/google-maps-component.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    GoogleMapsComponentModule,
    DatetimeSelectModule,
    TranslateModule.forChild()
  ],
  declarations: [
    AddressSearchComponent,
    CalendarLdComponent,
    DatetimeSelectComponent, DatetimeSelectModal
  ],
  exports: [
    AddressSearchComponent,
    CalendarLdComponent,
    DatetimeSelectComponent, DatetimeSelectModal,
    GoogleMapsComponentModule,
  ],
})
export class ComponentsModule {}
